module.exports = __webpack_public_path__ + "img/pl.98377a7b.png";